export enum FormElementError {
  Required = 0,
  NotNumber = 1,
  InvalidEmail = 2,
  InvalidNumberOfCharacters = 3,
  NotAllPagesViewed,
  NoData = 5,
}
